import { render, staticRenderFns } from "./FoodSharePoint.vue?vue&type=template&id=1a179d80&scoped=true"
import script from "./FoodSharePoint.vue?vue&type=script&lang=js"
export * from "./FoodSharePoint.vue?vue&type=script&lang=js"
import style0 from "./FoodSharePoint.vue?vue&type=style&index=0&id=1a179d80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a179d80",
  null
  
)

export default component.exports